/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
export let authConfig = {
    unauthorizedUrlRedirect: '/login',
    logoutUrlRedirect: '/login'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/authorization/auth.config.ts